var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 186,
    height: 186,
    viewBox: "0 0 186 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8852CC",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.945,
    cy: 92.834,
    r: 92.477,
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.7 83.9c-5.588 0-10.118 4.527-10.118 10.114 0 5.586 4.53 10.114 10.118 10.114s10.118-4.528 10.118-10.114c0-5.587-4.53-10.115-10.118-10.115zm0 15.412a5.3 5.3 0 1 1 0-10.597 5.3 5.3 0 1 1 0 10.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.121 62.035l-63.253-6.951a8.89 8.89 0 0 0-6.835 1.906c-1.892 1.42-3.106 3.525-3.36 5.83l-1.158 9.193h-3.591c-5.098 0-8.92 4.372-8.92 9.305v45.854c-.13 4.704 3.707 8.618 8.568 8.743.117.003.234.003.352.002h63.6c5.098 0 9.732-3.812 9.732-8.745v-1.794c1.58-.295 3.08-.906 4.402-1.794 1.877-1.529 3.079-3.695 3.36-6.054l5.329-45.517c.543-4.945-3.124-9.392-8.226-9.978zm-9.5 65.137c0 2.466-2.548 4.26-5.097 4.26h-63.6c-2.303.066-4.224-1.688-4.292-3.916a3.88 3.88 0 0 1 .005-.344v-8.296l17.957-12.781c2.157-1.603 5.195-1.46 7.182.336l12.628 10.763a11.107 11.107 0 0 0 6.835 2.466 10.811 10.811 0 0 0 5.56-1.457l22.823-12.78v21.749zm0-27.02l-25.254 14.24c-2.169 1.242-4.914 1.017-6.835-.561l-12.744-10.875c-3.652-3.037-8.99-3.224-12.859-.449L53.637 113.27V81.318c0-2.466 1.738-4.82 4.287-4.82h63.6c2.723.109 4.922 2.188 5.098 4.82v18.835zm13.096-28.745l-.005.045-5.444 45.518a3.767 3.767 0 0 1-1.506 3.027c-.464.448-1.507.672-1.507.897V81.318c-.182-5.107-4.451-9.19-9.73-9.305H66.148l1.042-8.745a5.123 5.123 0 0 1 1.738-2.915 5.463 5.463 0 0 1 3.476-.897l63.137 7.063c2.548.234 4.417 2.423 4.175 4.888z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoIcon);
export default __webpack_public_path__ + "static/media/photo-icon.ac307973b4f9b61395b4bfaa69ccd538.svg";
export { ForwardRef as ReactComponent };